import React from 'react';
import { X } from 'lucide-react';

const AssignDeliveryDialog = ({
  orderNo, branches, selectedBranch, onSelectBranch,
  assigning, onConfirm, onClose
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
      <div className="p-6 border-b flex justify-between items-center">
        <h3 className="text-lg font-bold">指派配送</h3>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <X className="w-6 h-6" />
        </button>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-sm text-gray-500">订单号：{orderNo}</p>
        <div>
          <label className="block text-sm font-medium mb-2">选择配送方式 *</label>
          <select
            value={selectedBranch}
            onChange={e => onSelectBranch(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          >
            <option value="">请选择</option>
            <option value="hq">🏪 总店自行配送（全额收入）</option>
            {branches.map(b => (
              <option key={b.id} value={b.id}>
                {b.name}（佣金：{(b.commission_rate * 100).toFixed(1)}%）
              </option>
            ))}
          </select>
        </div>
        {selectedBranch === 'hq' && (
          <div className="bg-green-50 border border-green-200 rounded-lg px-4 py-3 text-sm text-green-700">
            总店自行配送，无需分佣，全额收入归总店
          </div>
        )}
        {selectedBranch && selectedBranch !== 'hq' && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-4 py-3 text-sm text-yellow-700">
            指派后分店店长将收到接单通知，请确认分店有相应库存
          </div>
        )}
      </div>
      <div className="p-6 border-t flex space-x-3">
        <button onClick={onClose}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          取消
        </button>
        <button onClick={onConfirm} disabled={assigning}
          className={`flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg ${assigning ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}>
          {assigning ? '指派中...' : '确认指派'}
        </button>
      </div>
    </div>
  </div>
);

export default AssignDeliveryDialog;